import { render } from "./AlarmPage.vue?vue&type=template&id=60b59c6e&scoped=true"
import script from "./AlarmPage.vue?vue&type=script&lang=js"
export * from "./AlarmPage.vue?vue&type=script&lang=js"

import "./AlarmPage.vue?vue&type=style&index=0&id=60b59c6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b59c6e"]])

export default __exports__